import { useMemo } from 'react';
import { mergeSizes } from '../../utils/spacing/mergeSizes';
/**
 * Custom hook to extract SpacingProps from a given set of props and transforms
 * them to an CSS shorthand notation array with four entries
 *
 * @param {Object} props List of props
 * @returns {SpacingShorthandList}
 */
export function useSpacing({ spacing: shorthand, spaceStackStart: stackStart, spaceInlineEnd: inlineEnd, spaceStackEnd: stackEnd, spaceInlineStart: inlineStart, }) {
    return useMemo(() => mergeSizes(shorthand, [stackStart, inlineEnd, stackEnd, inlineStart]), [shorthand, stackStart, inlineEnd, stackEnd, inlineStart]);
}
//# sourceMappingURL=useSpacing.js.map